import { FooterBottom } from "./footer__bottom";
import { FooterTop } from "./footer__top";
import { FooterLine, FooterWrapper } from "./style";

export const Footer = () => (
  <FooterWrapper>
    <FooterTop />
    <FooterLine />
    <FooterBottom />
  </FooterWrapper>
);
